import React, { useEffect, useState } from "react";
import { isMobile, isTablet } from "react-device-detect";
import Dialog from "@material-ui/core/Dialog";
import { Backdrop, CircularProgress, DialogContent, Divider } from "@material-ui/core";
import { updateFormStateStructureByElemType } from "../SectionLayoutLogic";
import { useStyles } from "./GridModalStyle/listviewModalStyle";
import style from "../../LeftNavigation/DesignerControls/BasicControls.module.css";
import ELEMENT from "../../../UI/BasicFormControls/ELEMENT";
import {
  fetchAndUpdateJSON,
  getGdToken,
  getWIToken,
  setMandatoryControls,
  updatedComponentInFormStates,
  updatePartialJSON
} from "../../../components/IFormDesignerLayout/IFormDesignerLogic";
import axios from "../../../axios";
import { useDispatch } from "../../../Redux";
import CustomizedAlert from "../../../ReusableComponents/Alert/CustomizedAlert";
import { functions } from "../ApplicationAPI/applicationApi";
import { clearMap, updateGridContexts } from "../../../Redux/Actions/FormStateActions";
import { GetState, GetStateFromData, GetExactDevice } from "../../CustomHooks/CustomHooks";
import { handleFocus, getHooksId } from "../../../Resources/globalFunctions";
import GridModalHeader from "../../../UI/BasicFormControls/TableComponent/GridModalHeader";
import GridModalFooter from "../../../UI/BasicFormControls/TableComponent/GridModalFooter";
import {clearAdvanceListview, setListViewRowIndexInAdvListView} from "../RequestLogic";
import { triggerEventCalls } from "../../../ReusableComponents/Events/EventExecutionLogic";
import { updateSubFormJSON } from "../../../UI/BasicFormControls/TableComponent/gridUtils";

function ListviewPopUp(props) {
  const translationStyles =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";

  const contexts = GetStateFromData(props.containerId);
  const gridContexts = GetStateFromData(props.containerId, "data2");

  const { listViewAddRecordFrom, advanceListviewStateJson,openCanvasForPreviewAdvance, selectedRowIndex, currentAdvanceListviewStateJson, subFormListviewJson } = gridContexts.gridStates;
  const {
    listviewColumnInfo,
    formMataData,
    setRecordCount,
    formState2,
    showAlertConfirmNotifications,
    canvasTop,
    imageBaseURL,
    updateJson,
    device,
    listviewFrameLayoutJsonClone_listviewMap
  } = contexts.contexts;

  const { updatedComponentInFormState } = updateJson;

  const themeData = formState2.theme;
  const controlThemeData = themeData?.["ButtonStyle"];
  const {isDesktop, isTablet,isMobile} = GetExactDevice();
  // const controlThemeData1 = formState2.theme?.['InputStyle']; 

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [refreshCount, setRefreshCount] = useState(0);
  const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification"
  });
  const showFooter = props?.data?.popupStyle?.["ShowFooter"] !== "false";
  const showFooterWhenDisabled = props?.data?.popupStyle?.["ShowFooterWhenDisabled"] !== "false";

  const classes = useStyles({
    isMobile,
    popupStyle: props?.data?.popupStyle || {},
    gridStyle: props?.subFormListviewJson?.style || {},
    isTablet,
    dialogPaperWidth: "100%",
    isArabic: translationStyles,
    primaryColor: `${controlThemeData["PrimaryButtonFontColor"] || "#fff"} !important`,
    primaryBackgroundColor: `${controlThemeData["PrimaryButtonBackgroundColor"] || "var(--button_color)"} !important`,
    primaryBorderColor: `${controlThemeData["PrimaryButtonBorderColor"] || "var(--button_color)"} !important`,
    secondaryColor: `${controlThemeData["SecondaryButtonFontColor"] || "var(--button_color)"} !important`,
    secondaryBorderColor: `${controlThemeData["SecondaryButtonBorderColor"] || "var(--button_color)"} !important`
  });

  function showServerError(isGlobalError, error) {
    if (window.loading && isGlobalError) {
      window.loading(false);
    } else {
      setLoading(false);
    }

    setAlertData({
      open: true,
      showConfirm: "showNotification",
      alertType: "error",
      alertContentKey: "There is some issue at server end."
    });
  }

  function checkColumnType(columnList, columnName) {
    if (columnList) {
      for (let column of columnList) {
        if (column.style.ColumnName === columnName) {
          return column.style.complexFieldType;
        }
      }
    }
  }

  let flag = false
  let obj1 = {}
  function chegit(child, key){
    if (Array.isArray(child)) {
      for (let item of child) {
        if(item?.style?.CustomMasking !== undefined && item?.style?.MaskingValue === "CustomMasking" && item?.style?.ColumnName === key && item?.style?.complexFieldType === "Float"){
          flag = true
          obj1 = item?.style?.CustomMasking
          //  console.log("hell yeah")
        }
        if (item.children) {
          chegit(item.children, key);
        }
      }
    } else if (child.children) {
      chegit(child.children, key);
    }
  }



  function clearNodeValues(node) {
    if (!node || typeof node !== "object") return;
    if (Array.isArray(node)) {
      for (let i = 0; i < node.length; i++) {
        clearNodeValues(node[i]);
      }
      return;
    }
    if ("value" in node && "elem_type" in node) {
      node.value = "";
    }
    if (node.children) {
      clearNodeValues(node.children);
    }
    if (node.subform) {
      clearNodeValues(node.subform);
    }
  }

  function resetListviewJson(type, newJson) {
    if (listviewFrameLayoutJsonClone_listviewMap?.get(props.data.id)) {
      const isBatchAction = type === "next" || type === "previous";
      // const jsonCopy = structuredClone(listviewFrameLayoutJsonClone_listviewMap.get(props.data.id));
      if (newJson?.listviewFrameLayoutJson) {
        let returned_listviewFrameLayoutJson = updateSubFormJSON(newJson?.listviewFrameLayoutJson, true);
        props.data.listviewFrameLayoutJson = returned_listviewFrameLayoutJson
      } else {
        clearNodeValues(props.data.listviewFrameLayoutJson);
        // props.data.listviewFrameLayoutJson = jsonCopy
      }
      // if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" && currentAdvanceListviewStateJson){
      //   fetchAndUpdateJSON(currentAdvanceListviewStateJson, props?.data?.id, props.data)
      //   dispatch(updateGridContexts({ name: "currentAdvanceListviewStateJson", key: props.containerId, value: { ...currentAdvanceListviewStateJson}, renderAdvListView: false, renderListView: false}));
      // }

      if(type === "close" && openCanvasForPreviewAdvance === "advanceListviewPopupInPreview"){
        updatePartialJSON(props.data.id, props.data, false);
      }

     

      if((type === "refresh" || type==="next" || type==="previous") || isBatchAction){
        dispatch(
          updateGridContexts({
            name: "subFormListviewJson",
            key: props.containerId,
            value: type === "refresh" ? { ...props.data, modalType: "A" } : (type==="next" || type==="previous")? { ...props.data, modalType: "M" } : props.data,
          })
        );
      }

      if (type !== "refresh" && !isBatchAction) {
        dispatch(
          updateGridContexts({
            name: "subFormListviewJson",
            key: props.containerId,
            value: undefined,
            renderListView: true,
            // renderListView: openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" && currentAdvanceListviewStateJson ? true : false,
            // renderAdvListView: openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" && currentAdvanceListviewStateJson ? true : false
          })
        );
      } 
    }
  }

  useEffect(() => {
      document.querySelector('[id*="_listview_crossIcon"]')?.focus();
    }, [refreshCount, document.querySelector('[id*="_listview_crossIcon"]')]);

  useEffect(() => {
    requestAnimationFrame(() => {
      if (window.listViewLoad) {
          window.listViewLoad(getHooksId(props?.data), props?.subFormListviewJson?.modalType);
          functions.updateJSON();
        }
        const e = { type: "load" };
    if (
      props?.data &&
      props?.data?.event &&
      props?.data?.event.Events &&
      props?.data?.event.Events.load
    ) {
      triggerEventCalls(
        e,
        { id: props?.data?.id },
        props?.data?.event,
        "form",
        () => {},
        contexts,
        props.containerId,
        props.data,
        "load"
      );
    }
    });

    
  }, [refreshCount]);

  function validateListview() {
    // const currentListviewColumnInfoMandatory = listviewColumnInfo.get(props.data.id) || new Map();
    const isValid = window.isComponentValidated(
      "buttonSubform",
      {
        ...(subFormListviewJson?.listviewFrameLayoutJson?.children?.[0]?.children?.[0] || {}),
        validationType: "listview",
        validationId: props.data?.id
      },
      undefined,
      // currentListviewColumnInfoMandatory
    );

    return isValid;
  }

  function getComplexFieldType(columnList = [], columnName) {
    if (columnList.length) {
      for (let column of columnList) {
        if (column.style.ColumnName === columnName) {
          return column.style.complexFieldType;
        }
      }
    }
  }

  let isCustomMaskingAdded = false;
  let customMaskingObj = {};

  function customMaskingChecks(child, key) {
    if (Array.isArray(child)) {
      for (let item of child) {
        if (
          item?.style?.CustomMasking !== undefined &&
          item?.style?.MaskingValue === "CustomMasking" &&
          item?.style?.ColumnName === key &&
          item?.style?.complexFieldType === "Float"
        ) {
          isCustomMaskingAdded = true;
          customMaskingObj = item?.style?.CustomMasking;
        }
        if (item.children) {
          customMaskingChecks(item.children, key);
        }
      }
    } else if (child.children) {
      customMaskingChecks(child.children, key);
    }
  }

  function formatValue(dataContent) {
    const tableId = props.data?.id?.split("_")?.[0];
    const currentListviewColumnInfo = listviewColumnInfo.get(tableId);
    console.log("ListViewColumnInfo57" + listviewColumnInfo)
    console.log("CurrentListViewColumnInfo57" + currentListviewColumnInfo)

    if (currentListviewColumnInfo) {
      for (let [key, value] of currentListviewColumnInfo) {
        const colType = getComplexFieldType(props?.data?.columnList, key);
        let reformatRegex = /[*]/g;

        let customMaskingValue;
        customMaskingChecks(props?.data?.listviewFrameLayoutJson, key);

        if (colType === "Float" && isCustomMaskingAdded) {
          if (customMaskingObj?.asep) {
            customMaskingValue = value.split(customMaskingObj.asep).join("");
          }
          if (customMaskingObj?.adec) {
            customMaskingValue = customMaskingValue.replace(customMaskingObj.adec, ".");
          }
          customMaskingValue = customMaskingValue.replace(/[^0-9.-]/g, "");
        } else if (colType === "Float") {
          reformatRegex = /[^0-9.]/g;
        } else if (colType === "Integer" || colType === "Long") {
          reformatRegex = /[^0-9]/g;
        }

        if (typeof value === "string") {
          if (colType === "Float" && isCustomMaskingAdded) {
            dataContent[key] = customMaskingValue;
          } else {
            dataContent[key] = value.replace(reformatRegex, "");
          }
        } else {
          dataContent[key] = value;
        }
      }
    }
    return dataContent;
  }

  function hooksValidation(type = "") {
    const isBatchAction = type === "next" || type === "previous";
    let result = true;
    let typeOfRow = "AddRow";
    let rowType = "A";

    if (type === "modify" || isBatchAction) {
      typeOfRow = "ModifyRow";
      rowType = "M";
    }

    if (window.tableOperation) {
      result = window.tableOperation(getHooksId(props?.data), typeOfRow);
      functions.updateJSON();
    }

    let customValidationResult = true;
    if (window.customListViewValidation) {
      customValidationResult = window.customListViewValidation(
        getHooksId(props?.data),
        type === "modify" || isBatchAction ? "M" : "A",
        type === "modify" ? "ModifyRow" : type === "next" ? "NextRow" : type === "previous" ? "PreviousRow" : "AddRow"
      );
      functions.updateJSON();
    }

    return result && customValidationResult;
  }

  function postAddRowAPI(type, data) {
    const isBatchAction = type === "next" || type === "previous";

    const tableId = props.data?.id?.split("_")?.[0];
    const currentListviewColumnInfo = listviewColumnInfo.get(tableId);

    const isNewRow = type === "add" || type === "duplicate" || type === "refresh";
    window.setFormMoified(true);

    if (!props.data.rowData) {
      props.data.rowData = [];
    }


    const rowData = data.valueJson;

    if (type === "modify" || isBatchAction) {
      const extraRowData = window?.currentRowData;

      if (extraRowData && extraRowData.id === selectedRowIndex) {
        for (let key in rowData) {
          if (extraRowData.hasOwnProperty(`${rowData[key].name}_extraOptions`)) {
            rowData[key].extraOptions = extraRowData[`${rowData[key].name}_extraOptions`];
          }
          if (extraRowData.hasOwnProperty(`${rowData[key].name}_clearOptions`)) {
            rowData[key].clearCombo = extraRowData[`${rowData[key].name}_clearOptions`];
          }
          if (extraRowData.hasOwnProperty(`${rowData[key].name}_removeOptionIndex`)) {
            rowData[key].removeOptionIndex = extraRowData[`${rowData[key].name}_removeOptionIndex`];
          }
        }
      }

      props.data.rowData[selectedRowIndex] = rowData;
    } else {
      props.data.rowData.push(rowData);
    }

    if (type === "refresh" || isBatchAction) {
      if (currentListviewColumnInfo) {
        for (let [key, value] of currentListviewColumnInfo) {
          if (typeof value === "boolean") {
            currentListviewColumnInfo.set(key, false);
          } else {
            currentListviewColumnInfo.delete(key);
          }
        }
      }
    }

    // if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" && currentAdvanceListviewStateJson && subFormListviewJson && openCanvasForPreview === "showDataAdditonSection") {
    //   dispatch(updateGridContexts({ name: "currentAdvanceListviewStateJson", key: props.containerId, value: { ...currentAdvanceListviewStateJson }, renderAdvListView: true, renderListView: false}));
    //   dispatch(
    //     updateGridContexts({
    //       name: "subFormListviewJson",
    //       key: props.containerId,
    //       value: { ...props.subFormListviewJson},
    //       renderListView: true, 
    //       // renderCanvas: true
    //     })
    //   );
    // }
    // else{
    //   dispatch(
    //     updateGridContexts({
    //       name: "subFormListviewJson",
    //       key: props.containerId,
    //       value: { ...props.data},
    //       renderListView: true, 
    //       // renderCanvas: true
    //     })
    //   );
    // }

    if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" && currentAdvanceListviewStateJson){
      updatePartialJSON(props.data.id, props.data, false);
    }
    else{
      updatePartialJSON(props.data.id, props.data, true);
    }
    if (props?.data?.style) {
      props.data.style["updateFormState"] = new Date();
    }
    if(!isBatchAction) {
      callOnClose(type);
    }
    setRecordCount(props.data.id, true);
    setLoading(false);
    
    

    dispatch(
      updateGridContexts({
        name: "listviewClearState",
        key: props.containerId,
        value: true,
        renderListView: true
      })
    );
    if (isNewRow) {
      if (window.addRowPostHook) {
        window.addRowPostHook(getHooksId(props?.data), "manual");
        functions.updateJSON();
      }
    } else if (type === "modify" || isBatchAction) {
      if (window.modifyRowPostHook) {
        window.modifyRowPostHook(getHooksId(props?.data), selectedRowIndex);
        functions.updateJSON();
      }
    }
  

  }

  function addRowSaveAndClose(type = "add"){
    if (type !== "duplicate" && !validateListview()) return;

    setLoading(true);

    const shouldAdd = hooksValidation(type);
    if (shouldAdd) {
    // if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" && currentAdvanceListviewStateJson){
    addRow("add", shouldAdd);
      // setListViewRowIndexInAdvListView(jsonToSend)
      // .then((response) => {
      //   if (response?.status === "200" || response?.status === 200){
      //     addRow("add", shouldAdd);
      //   } else {
      //     showServerError(true);
      //     setLoading(false);
      //   }
      // })
      // .catch((error) => {
      //   showServerError(true, error);
      //   setLoading(false);
      // });
    // }
    // else{
    //   addRow("add");
    // }
    } else {
      setLoading(false)
    }
  }

  function addRowSaveAndContinue(type = "refresh") {
    if (type !== "duplicate" && !validateListview()) return;

    setLoading(true);

    const shouldAdd = hooksValidation();
    addRow("refresh", shouldAdd);

    // if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" && currentAdvanceListviewStateJson){




    // }
    // else{
    //   addRow("refresh")
    // }
  }

  function addRow(type = "add", shouldAdd){
    const isBatchAction = type === "next" || type === "previous";

    let shouldAdd1 = shouldAdd
    if(type === "modify" || type === "duplicate"){
      
      if (type !== "duplicate" && !validateListview()) return;

      setLoading(true);

      shouldAdd1 = hooksValidation(type);
    }
    

    if (shouldAdd1) {
      requestAnimationFrame(() => {
        // const dataContent = {};
        // formatValue(dataContent);

      const jsonToSend = {
        witoken: getWIToken(props.containerId), // getWIToken()
        gdtoken: getGdToken(props.containerId), //getGdToken()
        controlId: props.data.id,
        // dataValue: dataContent,
        ...(type === "modify" || type === "duplicate" || isBatchAction ? { rowIndex: selectedRowIndex } : {}),
        ...(type === "duplicate" ? { duplicateRow: true } : {})
      };

      const remainingURL = type === "modify" || isBatchAction ? "/tableAction/modifyRowInAdvListview" : "/tableAction/addRowInAdvListview";

      axios
        .post(remainingURL, jsonToSend, { withCredentials: true })
        .then((response) => {
          if (response?.data?.status === "0") {
            postAddRowAPI(type, response.data);

            if (type === "modify" || type ==="duplicate"){
              const jsonToSendClear = {
                gdtoken: getGdToken(props.containerId),
                controlId: props.data.id,
              }
              
            clearAdvanceListview(jsonToSendClear)
                  .then((res) => {
                    // console.log(res,"res2 == clearAdvanceListview")
                    // if (window.modifyRowPostHook) {
                    //   window.modifyRowPostHook(props.data.id, selectedRowIndex);
                    //   functions.updateJSON();
                    // }
                  })
                  .catch((error) => {
                    showServerError(true, error);
                  });
              
                  // .then(() => {
                  //   if (window.modifyRowPostHook) {
                  //     window.modifyRowPostHook(props.data.id, selectedRowIndex);
                  //     functions.updateJSON();
                  //   }
                  // })
                  // .catch((error) => {
                  //   showServerError(true, error);
                  // });
            }
             else if (type === "add"){
              const jsonToSend = {
                rowIndex: "-2",
                controlId: props.data.id,
                modifyFlag: "no",
                witoken: getWIToken(props.containerId),
                gdtoken: getGdToken(props.containerId)
              };
              clearAdvanceListview(jsonToSend)
                  .then((response) => {
                    // console.log(response, "clearAdvanceListview")
                    if (response?.status === "200" || response?.status === 200){
                      let hookReturn = true;
                      // if (window.addRowPostHook) {
                      //   window.addRowPostHook(props.data.id, "manual");
                      //   functions.updateJSON();
                      // }
                      if (window.subformDoneClick) {
                        hookReturn = window.subformDoneClick(getHooksId(props?.data));
                        functions.updateJSON();
                      }
                      if(hookReturn || hookReturn === undefined) {
                        callOnClose("close");
                        setMandatoryControls([]);
                      }
                    } else {
                      showServerError(true);
                    }
                  })
                  .catch((error) => {
                    showServerError(true, error);
                  });
            } else if (type === "refresh") {
              const jsonToSend = {
                rowIndex: "-2",
                controlId: props.data.id,
                modifyFlag: "no",
                witoken: getWIToken(props.containerId),
                gdtoken: getGdToken(props.containerId)
              };
              const jsonToSendAttr = {
                rowIndex: "-1",
                controlId: props.data.id,
                modifyFlag: "no",
                witoken: getWIToken(props.containerId),
                gdtoken: getGdToken(props.containerId)
              };
              clearAdvanceListview(jsonToSend)
                  .then(() => {
                    setListViewRowIndexInAdvListView(jsonToSendAttr)
                        .then((response1) => {
                          if (response1?.data?.ele_JSON?.listviewFrameLayoutJson) {
                            callOnClose(type, response1?.data?.ele_JSON);
                          }
                           setRefreshCount(prev => prev + 1);
                        })
                        .catch((error) => {
                          showServerError(true, error);
                          setLoading(false);
                        });
                  })
                  .catch((error) => {
                    showServerError(true, error);
                  });
            } else if (isBatchAction) {
              const jsonToSend = {
                rowIndex: "-2",
                controlId: props.data.id,
                modifyFlag: "yes",
                witoken: getWIToken(props.containerId),
                gdtoken: getGdToken(props.containerId)
              };
              clearAdvanceListview(jsonToSend)
                  .then(() => {
                    const newIndex = type === "next" ? (selectedRowIndex + 1) : (selectedRowIndex -1);
                    dispatch(
                      updateGridContexts({ key: props.containerId, name: "selectedRowIndex", value: newIndex, renderListView: true })
                    );
                    jsonToSend.rowIndex = newIndex;
                    setListViewRowIndexInAdvListView(jsonToSend)
                        .then((response1) => {
                          if (response1?.data?.ele_JSON?.listviewFrameLayoutJson) {
                            callOnClose(type, response1?.data?.ele_JSON);
                          }
                          setRefreshCount(prev => prev + 1);
                        })
                        .catch((error) => {
                          showServerError(true, error);
                          setLoading(false);
                        });
                  })
                  .catch((error) => {
                    showServerError(true, error);
                  });
            }
          } else if (response?.data?.status === "-1") {
            setLoading(false);
            showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: "DUPLICATE_ROW_MESSAGE"
            });
          } else if (response?.data?.status === "-2") {
            setLoading(false);
            showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: "INVALID_DATA_MESSAGE"
            });
          }
        })
        .catch(() => {
          listviewColumnInfo.clear();
          // dispatch(clearMap());
          dispatch(updateGridContexts({ key: props.containerId, name: "listviewClearState", value: true }));
          setLoading(false);
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: "Something_Went_Wrong"
          });
        });
      });
    } else {
      setLoading(false);
    }
  }

  const callOnClose = (type, newJson) => {
    const isBatchAction = type === "next" || type === "previous";
    resetListviewJson(type, newJson);
    if (type !== "refresh" && !isBatchAction) {
      listviewColumnInfo.clear();
      // dispatch(clearMap());
      dispatch(updateGridContexts({ name: "listViewAddRecordFrom", key: props.containerId, value: false }));
      dispatch(updateGridContexts({ name: "selectedRowIndex", key: props.containerId, value: -1 }));
      props.closeSubformOnPreview();
      handleFocus(`${props.data?.id}_add_record_btn`);
    } 
    // else {
      const tableId = props.data?.id?.split("_")?.[0];
      const currentListviewColumnInfo = listviewColumnInfo.get(tableId);

      if (currentListviewColumnInfo) {
        currentListviewColumnInfo.clear();
      }
      listviewColumnInfo.clear();
      // dispatch(clearMap());      
    // }
  };

  function closeLV() {
    // if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" && currentAdvanceListviewStateJson){
      const jsonToSend = {
        rowIndex: props.listviewModifyMode ? "-2" : "-3",
        controlId: props.subFormListviewJson.id,
        modifyFlag: "no",
        witoken: getWIToken(props.containerId),
        gdtoken: getGdToken(props.containerId)
      };
      clearAdvanceListview(jsonToSend)
      .then((response) => {
        if (response?.status === "200" || response?.status === 200){
          let hookReturn = true;
          if (window.subformDoneClick) {
            hookReturn = window.subformDoneClick(getHooksId(props?.data));
            functions.updateJSON();
          }
          if(hookReturn || hookReturn === undefined) { 
          if (typeof window.msgOnCloseOverlay === "function") {
            const closeOverlayMessage = window.msgOnCloseOverlay(props?.data?.id);
      
            if (closeOverlayMessage) {
              setAlertData({
                open: true,
                showConfirm: "showconformationDialogBox",
                alertContentKey: closeOverlayMessage,
                Button1Key: "Ok"
              });
              functions.updateJSON();
            } else {
              callOnClose("close");
              // functions.showMess(["The Control Not Present"], "error");
            }
          } else {
            callOnClose("close");
          }
          setMandatoryControls([]);
          props.setOpen(false)
          }
          props.setListviewModifyMode(false)
        } else {
          showServerError(true);
        }
      })
      .catch((error) => {
        showServerError(true, error);
      });
  }

  function handleClose() {
    if (window.msgOnCloseOverlay) {
      const closeOverlayMessage = window.msgOnCloseOverlay(props?.data?.id);
      functions.updateJSON();

      if (typeof closeOverlayMessage === "string" && closeOverlayMessage !== "") {
        setAlertData({
          open: true,
          showConfirm: "showconformationDialogBox",
          alertContentKey: closeOverlayMessage,
          Button1Key: "Ok"
        });
      } else if(closeOverlayMessage === true || closeOverlayMessage === undefined || closeOverlayMessage == "") {
        closeLV();
      }
    } else {
      closeLV();
    }
  }

  // function previousRowHandler() {
  //   setLoading(true);

  //   const prevIndex = selectedRowIndex - 1;

  //   if (prevIndex >= 0) {
  //     const jsonToSend = {
  //       rowIndex: prevIndex,
  //       controlId: props.data.id,
  //       modifyFlag: "yes",
  //       witoken: getWIToken(props.containerId),
  //       gdtoken: getGdToken(props.containerId)
  //     };

  //     setListViewRowIndexInAdvListView(jsonToSend)
  //     .then((response) => {
  //       if (response?.status === "200" || response?.status === 200){
  //         dispatch(
  //           updateGridContexts({ key: props.containerId, name: "selectedRowIndex", value: prevIndex, renderListView: true })
  //         );

  //         listviewColumnInfo.clear();
  //         // dispatch(clearMap());
  //         const tableId = props.data?.id?.split("_")?.[0];
  //         let currentListviewColumnInfo = listviewColumnInfo.get(tableId);

  //         if (!currentListviewColumnInfo) {
  //           listviewColumnInfo.set(tableId, new Map());
  //           currentListviewColumnInfo = listviewColumnInfo.get(tableId);
  //           Object.values(props.data.rowData[prevIndex]).forEach((rowObject) => {
  //             currentListviewColumnInfo.set(rowObject.name, rowObject.value);
  //           });
  //         }

  //         dispatch(updateGridContexts({ key: props.containerId, name: "listviewClearState", value: false }));

  //         setRecordCount(props.data.id, true);
  //         setRefreshCount((prev) => prev +1);
  //       } else {
  //         showServerError(true);
  //         setLoading(false);
  //       }
  //     })
  //     .catch((error) => {
  //       showServerError(true, error);
  //       setLoading(false);
  //     });
  //   }
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 300);
  // }

  // function saveAndPrevious1() {
  //   if(document?.activeElement?.blur) {
  //     document.activeElement.blur();
  //   }
  //   if(!validateListview()) return

  //   setLoading(true);
  //   var dataContent = {};
  //   let value1;
  //   // dispatch(updateGridContexts({ name: "listViewAddRecordFrom", key: props.containerId, value: false }));

  //   const tableId = props.data?.id?.split("_")?.[0];
  //   let currentListviewColumnInfo = listviewColumnInfo.get(tableId);
  //   if (currentListviewColumnInfo) {
  //     for (let [key, value] of currentListviewColumnInfo) {
  //       let colType = checkColumnType(props?.data?.columnList, key);
  //       let reformatRegex = /[*]/g;
  //       chegit(props?.data?.listviewFrameLayoutJson, key);
  //       if (colType === "Float" && flag) {
  //         if(obj1.asep){
  //           value1 = value.split(obj1?.asep).join("");
  //         }
  //         if(obj1?.adec){
  //           value1 = value1.replace(obj1?.adec, ".");
  //         }
  //         value1 = value1.replace(/[^0-9.-]/g, "");
  //       }
  //       else if (colType === "Float") {
  //         reformatRegex = /[^0-9.]/g;
  //       } else if (colType === "Integer" || colType === "Long") {
  //         reformatRegex = /[^0-9]/g;
  //       }
  //       if (typeof value === "string") {
  //         if (colType === "Float" && flag) {
  //           dataContent[key] = value1
  //         }
  //         else{
  //           dataContent[key] = value.replace(reformatRegex, "");
  //         }
  //       } else {
  //         dataContent[key] = value;
  //       }
  //     }
  //   }

  //   let customValidationResult = true;

  //   if (window.customListViewValidation) {
  //     customValidationResult = window.customListViewValidation(props.data.id, "M");
  //     functions.updateJSON();
  //   }

  //   if (customValidationResult) {
  //     var jsonToSend = {
  //       witoken: getWIToken(props.containerId), // getWIToken()
  //       controlId: props.data.id,
  //       gdtoken: getGdToken(props.containerId), //getGdToken()
  //       // dataValue: dataContent,
  //       rowIndex: selectedRowIndex
  //     };
  //     const shouldAdd = hooksValidation();

  //     var remainingURL = "/tableAction/modifyRowInAdvListview";
  //     const extraRowData = window?.currentRowData;
  //     axios
  //         .post(remainingURL, jsonToSend, { withCredentials: true })
  //         .then((response) => {
  //           var rowData = {};
  //           // let flag = false;
  //           Object.entries(response.data.valueJson).forEach((entry, index) => {
  //             let valueObj = entry[1];
  //             let itemValue = "";
  //             const tableId = props.data?.id?.split("_")?.[0];
  //             let currentListviewColumnInfo = listviewColumnInfo.get(tableId);
  //             if (currentListviewColumnInfo) {
  //               for (let [key, value] of currentListviewColumnInfo) {
  //                 if (valueObj.name === key) {
  //                   if(value === null || value === undefined){
  //                     value = ""
  //                   }
  //                   itemValue = value + "";
  //                 }
  //                 valueObj.value = itemValue;
  //               }
  //             }
  //           });

  //           rowData = response.data.valueJson;
  //           if (response?.data?.status === "0") {
  //             window.setFormMoified(true);
  //             if (extraRowData && extraRowData.id === selectedRowIndex) {
  //               for (let key in rowData) {
  //                 if (extraRowData.hasOwnProperty(`${rowData[key].name}_extraOptions`)) {
  //                   rowData[key].extraOptions = extraRowData[`${rowData[key].name}_extraOptions`];
  //                 }
  //                 if (extraRowData.hasOwnProperty(`${rowData[key].name}_clearOptions`)) {
  //                   rowData[key].clearCombo = extraRowData[`${rowData[key].name}_clearOptions`];
  //                 }
  //                 if (extraRowData.hasOwnProperty(`${rowData[key].name}_removeOptionIndex`)) {
  //                   rowData[key].removeOptionIndex = extraRowData[`${rowData[key].name}_removeOptionIndex`];
  //                 }
  //               }
  //             }

  //             props.data.rowData[selectedRowIndex] = rowData;

  //             listviewColumnInfo.clear();
  //             // dispatch(clearMap());
  //             // resetListviewJson();

  //             if (advanceListviewStateJson) {
  //               updatePartialJSON(props.data.id, props.data, true);
  //             } else {
  //               updatePartialJSON(props.data.id, props.data, true);
  //             }

  //             // if (props?.data?.style) {
  //             //   props.data.style["updateFormState"] = new Date();
  //             // }

  //             setTimeout(() => {
  //               setLoading(false);
  //             }, 300);
  //             // flag = true;
  //             dispatch(updateGridContexts({ key: props.containerId, name: "listviewClearState", value: true }));
  //             // dispatch(updateGridContexts({ key: props.containerId, name: "selectedRowIndex", value: -1 }));
  //             if (window.modifyRowPostHook) {
  //               window.modifyRowPostHook(props.data.id, selectedRowIndex);
  //               functions.updateJSON();
  //             }

  //             previousRowHandler()
  //           } else if (response?.data?.status === "-1") {
  //             setLoading(false);
  //             showAlertConfirmNotifications({
  //               open: true,
  //               showConfirm: "showNotification",
  //               alertType: "error",
  //               alertContentKey: "DUPLICATE_ROW_MESSAGE"
  //             });
  //           } else if (response?.data?.status === "-2") {
  //             setLoading(false);
  //             showAlertConfirmNotifications({
  //               open: true,
  //               showConfirm: "showNotification",
  //               alertType: "error",
  //               alertContentKey: "INVALID_DATA_MESSAGE"
  //             });
  //           }
  //         })
  //         .catch((error) => {
  //           console.log("modifyRowHandler - error -> ", error);
  //           setLoading(false);
  //           showAlertConfirmNotifications({
  //             open: true,
  //             showConfirm: "showNotification",
  //             alertType: "error",
  //             alertContentKey: "Something_Went_Wrong"
  //           });
  //         });

  //     const jsonToSendAttb = {
  //       rowIndex: selectedRowIndex - 1,
  //       controlId: props.data.id,
  //       modifyFlag: "no",
  //       witoken: getWIToken(props.containerId),
  //       gdtoken: getGdToken(props.containerId)
  //     };
  //     setListViewRowIndexInAdvListView(jsonToSendAttb)
  //         .then((response) => {
  //           if (response?.status === "200" || response?.status === 200){
  //             previousRowHandler()

  //             setRecordCount(props.data.id, true);
  //             setRefreshCount((prev) => prev +1);
  //           } else {
  //             showServerError(true);
  //             setLoading(false);
  //           }
  //         })
  //         .catch((error) => {
  //           showServerError(true, error);
  //           setLoading(false);
  //         });




  //   } else {
  //     setLoading(false);
  //   }
  // }

  function saveAndPrevious(type = "previous") {
    if (document?.activeElement?.blur) {
      document.activeElement.blur();
    }
    if (type !== "duplicate" && !validateListview()) return;

    setLoading(true);

    const shouldAdd = hooksValidation(type);
    addRow("previous", shouldAdd);
  }

  function saveAndNext(type = "next") {
    if (document?.activeElement?.blur) {
      document.activeElement.blur();
    }
    if (type !== "duplicate" && !validateListview()) return;

    setLoading(true);

    const shouldAdd = hooksValidation(type);
    addRow("next", shouldAdd);
  }

  // function saveAndNext1(){
  //   if(document?.activeElement?.blur) {
  //     document.activeElement.blur();
  //   }
  //   if(!validateListview()) return

  //   setLoading(true);
  //   var dataContent = {};
  //   let value1;
  //   // dispatch(updateGridContexts({ name: "listViewAddRecordFrom", key: props.containerId, value: false }));

  //   const tableId = props.data?.id?.split("_")?.[0];
  //   let currentListviewColumnInfo = listviewColumnInfo.get(tableId);
  //   if (currentListviewColumnInfo) {
  //     for (let [key, value] of currentListviewColumnInfo) {
  //       let colType = checkColumnType(props?.data?.columnList, key);
  //       let reformatRegex = /[*]/g;
  //       chegit(props?.data?.listviewFrameLayoutJson, key);
  //       if (colType === "Float" && flag) {
  //         if(obj1.asep){
  //           value1 = value.split(obj1?.asep).join("");
  //         }
  //         if(obj1?.adec){
  //           value1 = value1.replace(obj1?.adec, ".");
  //         }
  //         value1 = value1.replace(/[^0-9.-]/g, "");
  //       }
  //       else if (colType === "Float") {
  //         reformatRegex = /[^0-9.]/g;
  //       } else if (colType === "Integer" || colType === "Long") {
  //         reformatRegex = /[^0-9]/g;
  //       }
  //       if (typeof value === "string") {
  //         if (colType === "Float" && flag) {
  //           dataContent[key] = value1
  //         }
  //         else{
  //           dataContent[key] = value.replace(reformatRegex, "");
  //         }
  //       } else {
  //         dataContent[key] = value;
  //       }
  //     }
  //   }

  //   let customValidationResult = true;

  //   if (window.customListViewValidation) {
  //     customValidationResult = window.customListViewValidation(props.data.id, "M");
  //     functions.updateJSON();
  //   }

  //   if (customValidationResult) {

  //     const shouldAdd = hooksValidation();

  //     var jsonToSend = {
  //       witoken: getWIToken(props.containerId), // getWIToken()
  //       controlId: props.data.id,
  //       gdtoken: getGdToken(props.containerId), //getGdToken()
  //       // dataValue: dataContent,
  //       rowIndex: selectedRowIndex
  //     };

  //     var remainingURL = "/tableAction/modifyRowInAdvListview";
  //     const extraRowData = window?.currentRowData;
  //     axios
  //         .post(remainingURL, jsonToSend, { withCredentials: true })
  //         .then((response) => {
  //           var rowData = {};
  //           // let flag = false;
  //           Object.entries(response.data.valueJson).forEach((entry, index) => {
  //             let valueObj = entry[1];
  //             let itemValue = "";
  //             const tableId = props.data?.id?.split("_")?.[0];
  //             let currentListviewColumnInfo = listviewColumnInfo.get(tableId);
  //             if (currentListviewColumnInfo) {
  //               for (let [key, value] of currentListviewColumnInfo) {
  //                 if (valueObj.name === key) {
  //                   if(value === null || value === undefined){
  //                     value = ""
  //                   }
  //                   itemValue = value + "";
  //                 }
  //                 valueObj.value = itemValue;
  //               }
  //             }
  //           });

  //           rowData = response.data.valueJson;
  //           if (response?.data?.status === "0") {
  //             window.setFormMoified(true);
  //             if (extraRowData && extraRowData.id === selectedRowIndex) {
  //               for (let key in rowData) {
  //                 if (extraRowData.hasOwnProperty(`${rowData[key].name}_extraOptions`)) {
  //                   rowData[key].extraOptions = extraRowData[`${rowData[key].name}_extraOptions`];
  //                 }
  //                 if (extraRowData.hasOwnProperty(`${rowData[key].name}_clearOptions`)) {
  //                   rowData[key].clearCombo = extraRowData[`${rowData[key].name}_clearOptions`];
  //                 }
  //                 if (extraRowData.hasOwnProperty(`${rowData[key].name}_removeOptionIndex`)) {
  //                   rowData[key].removeOptionIndex = extraRowData[`${rowData[key].name}_removeOptionIndex`];
  //                 }
  //               }
  //             }

  //             props.data.rowData[selectedRowIndex] = rowData;

  //             listviewColumnInfo.clear();
  //             // dispatch(clearMap());
  //             // resetListviewJson();

  //             if (advanceListviewStateJson) {
  //               updatePartialJSON(props.data.id, props.data, true);
  //             } else {
  //               updatePartialJSON(props.data.id, props.data, true);
  //             }

  //             // if (props?.data?.style) {
  //             //   props.data.style["updateFormState"] = new Date();
  //             // }

  //             setTimeout(() => {
  //               setLoading(false);
  //             }, 300);
  //             // flag = true;
  //             dispatch(updateGridContexts({ key: props.containerId, name: "listviewClearState", value: true }));
  //             // dispatch(updateGridContexts({ key: props.containerId, name: "selectedRowIndex", value: -1 }));
  //             if (window.modifyRowPostHook) {
  //               window.modifyRowPostHook(props.data.id, selectedRowIndex);
  //               functions.updateJSON();
  //             }

  //             // nextRowHandler()
  //           } else if (response?.data?.status === "-1") {
  //             setLoading(false);
  //             showAlertConfirmNotifications({
  //               open: true,
  //               showConfirm: "showNotification",
  //               alertType: "error",
  //               alertContentKey: "DUPLICATE_ROW_MESSAGE"
  //             });
  //           } else if (response?.data?.status === "-2") {
  //             setLoading(false);
  //             showAlertConfirmNotifications({
  //               open: true,
  //               showConfirm: "showNotification",
  //               alertType: "error",
  //               alertContentKey: "INVALID_DATA_MESSAGE"
  //             });
  //           }
  //         })
  //         .catch((error) => {
  //           console.log("modifyRowHandler - error -> ", error);
  //           setLoading(false);
  //           showAlertConfirmNotifications({
  //             open: true,
  //             showConfirm: "showNotification",
  //             alertType: "error",
  //             alertContentKey: "Something_Went_Wrong"
  //           });
  //         });

  //     const jsonToSendAttb = {
  //       rowIndex: selectedRowIndex + 1,
  //       controlId: props.data.id,
  //       modifyFlag: "no",
  //       witoken: getWIToken(props.containerId),
  //       gdtoken: getGdToken(props.containerId)
  //     };
  //     setListViewRowIndexInAdvListView(jsonToSendAttb)
  //         .then((response) => {
  //           if (response?.status === "200" || response?.status === 200){
  //             // nextRowHandler()
  //             setRecordCount(props.data.id, true);
  //             setRefreshCount(prev => prev + 1);
  //           } else {
  //             showServerError(true);
  //             setLoading(false);
  //           }
  //         })
  //         .catch((error) => {
  //           showServerError(true, error);
  //           setLoading(false);
  //         });




  //   } else {
  //     setLoading(false);
  //   }
  // }

  // function nextRowHandler() {
  //   setLoading(true);

  //   const nextIndex = selectedRowIndex + 1;
  //   const totalLength = props.data.rowData.length - 1;

  //   if (nextIndex <= totalLength) {

  //     const jsonToSend = {
  //       rowIndex: nextIndex,
  //       controlId: props.data.id,
  //       modifyFlag: "yes",
  //       witoken: getWIToken(props.containerId),
  //       gdtoken: getGdToken(props.containerId)
  //     };

  //     setListViewRowIndexInAdvListView(jsonToSend)
  //     .then((response) => {
  //       if (response?.status === "200" || response?.status === 200){
  //         dispatch(
  //           updateGridContexts({ key: props.containerId, name: "selectedRowIndex", value: nextIndex, renderListView: true })
  //         );

  //         listviewColumnInfo.clear();
  //         // dispatch(clearMap());

  //         const tableId = props.data?.id?.split("_")?.[0];
  //         let currentListviewColumnInfo = listviewColumnInfo.get(tableId);

  //         if (!currentListviewColumnInfo) {
  //           listviewColumnInfo.set(tableId, new Map());
  //           currentListviewColumnInfo = listviewColumnInfo.get(tableId);
  //           Object.values(props.data.rowData[nextIndex]).forEach((rowObject) => {
  //             currentListviewColumnInfo.set(rowObject.name, rowObject.value);
  //           });
  //         }

  //         dispatch(updateGridContexts({ key: props.containerId, name: "listviewClearState", value: false }));

  //         setRecordCount(props.data.id, true);
  //         setRefreshCount(prev => prev + 1);
  //       } else {
  //         showServerError(true);
  //         setLoading(false);
  //       }
  //     })
  //     .catch((error) => {
  //       showServerError(true, error);
  //       setLoading(false);
  //     });
  //   }
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 300);
  // }
  const content = subFormListviewJson && subFormListviewJson?.listviewFrameLayoutJson !== undefined ? (
    <ELEMENT
      containerId={props.containerId}
      {...props}
      data={subFormListviewJson?.listviewFrameLayoutJson}
    />
  ) : null

  const dialog =  <Dialog
        open={props.open}
        classes={{ paper: classes.dialogPaper, root: classes.root }}
        onClose={(event,reason)=>{
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          handleClose()
        }}}
        // PaperProps={{
        //   tabIndex: -1
        // }}
        disable
        style={{ zIndex: 1298 }}
        container={() => document.getElementById("canvasId")}
        id={`${props.data.id}_listviewPopup`}
        aria-labelledby={`${props?.tableData.id}_listview_label`}
      >
        <GridModalHeader
          gridJSON={props?.tableData}
          imageBaseURL={imageBaseURL}
          isViewer={true}
          extraProps={{ handleClose }}
          modalType = {props.data.style.additionmethods}

        />

        <DialogContent dividers className={[classes.dialogContent, "scrollable"].join(" ")} style={{ backgroundColor: props?.subFormListviewJson?.popupStyle?.AdvListviewBackgroundColor || "transparent" }}>
         {content}
        </DialogContent>

        <Backdrop open={loading} className={[classes.backdrop, style.listviewLoaderBackdrop].join(" ")}>
          <CircularProgress size={30} />
          {/* <span className={style.listviewLoadingText}>loading...</span> */}
        </Backdrop>

        {showFooter && (showFooterWhenDisabled || props?.data?.style?.Enable !== "false") ? (
          <GridModalFooter
            modalType = {props.data.style.additionmethods}
            gridJSON={props?.tableData}
            formState2={formState2}
            isViewer={true}
            extraProps={{
              loading: loading,
              showOverlayBatchButtonPartial: !listViewAddRecordFrom,
              nextClick: saveAndNext,
              previousClick: saveAndPrevious,
              saveAndContinue: () => addRowSaveAndContinue("refresh"),
              saveAndClose: () => addRowSaveAndClose("add"),
              saveChanges: () => addRow("modify"),
              duplicateRow: () => addRow("duplicate"),
              handleClose: () => handleClose(),
              selectedRowIndex: selectedRowIndex,
              dataOfAdvFrom: false
            }}
        /> ) : null}
      </Dialog>
    
const sectionView = <div className={style.sectionview__container}>
  {
    props.data.popupStyle?.Header!=="false" &&
    <GridModalHeader
    gridJSON={props?.tableData}
    imageBaseURL={imageBaseURL}
    isViewer={true}
    extraProps={{ handleClose }}
    modalType = {props.data.style.additionmethods}
    />
  }

    <DialogContent dividers className={[classes.dialogContent].join(" ")} style={{ backgroundColor: props?.subFormListviewJson?.popupStyle?.AdvListviewBackgroundColor || "transparent" }}>
      {content}
    </DialogContent>

    <Backdrop open={loading} className={[classes.backdrop, style.listviewLoaderBackdrop].join(" ")}>
      <CircularProgress size={30} />
      {/* <span className={style.listviewLoadingText}>loading...</span> */}
    </Backdrop>

    <GridModalFooter
      modalType = {props.data.style.additionmethods}
      gridJSON={props?.tableData}
      formState2={formState2}
      isViewer={true}
      subFormListviewJson={subFormListviewJson}
      extraProps={{
        loading: loading,
        showOverlayBatchButtonPartial: !listViewAddRecordFrom,
        nextClick: saveAndNext,
        previousClick: saveAndPrevious,
        saveAndContinue: () => addRowSaveAndContinue("refresh"),
        saveAndClose: () => addRowSaveAndClose("add"),
        saveChanges: () => addRow("modify"),
        duplicateRow: () => addRow("duplicate"),
        handleClose: () => handleClose(),
        selectedRowIndex: selectedRowIndex,
        dataOfAdvFrom: false
      }}
    />

  </div>
  return (
    <>
     {props.data.style["additionmethods"] === 'Through Popup' ? dialog : sectionView }
      {alertData.open === true && <CustomizedAlert alertData={alertData} callOnClose={closeLV} />}
    </>
  );
}

export default ListviewPopUp;
